module.exports = __webpack_public_path__ + "static/media/isi.0b12ce87.jpg";